import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment';
import { deDE, enUS, esES, frFR, itIT, nbNO, svSE } from '@mui/x-date-pickers-pro/locales';
import React, { memo } from 'react';
import { useIntl } from 'react-intl';

const muiLocaleMap = {
  de: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
  en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  es: esES.components.MuiLocalizationProvider.defaultProps.localeText,
  fr: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  it: itIT.components.MuiLocalizationProvider.defaultProps.localeText,
  no: nbNO.components.MuiLocalizationProvider.defaultProps.localeText,
  sv: svSE.components.MuiLocalizationProvider.defaultProps.localeText,
};

/**
 * Wraps children with MUI's LocalizationProvider (moment adapter), resolving the
 * adapterLocale and localeText from the current react-intl locale. Kept as a
 * lazy-loaded wrapper around individual date-picker usages so that
 * @mui/x-date-pickers-pro and the moment adapter stay out of the main bundle.
 * @param {object} props - Component props
 * @param {React.ReactNode} props.children - The date picker(s) to localize
 */
const PickersLocalizationProviderComponent = ({ children }) => {
  const intl = useIntl();
  const localeKey = intl.locale?.split('-')[0] || 'en';
  const localeText = muiLocaleMap[localeKey] || muiLocaleMap.en;

  return (
    <LocalizationProvider
      adapterLocale={intl.locale}
      dateAdapter={AdapterMoment}
      localeText={localeText}
    >
      {children}
    </LocalizationProvider>
  );
};

PickersLocalizationProviderComponent.displayName = 'PickersLocalizationProvider';

const PickersLocalizationProvider = memo(PickersLocalizationProviderComponent);

export default PickersLocalizationProvider;
